<template>
  <div class="home-faq">
    <div class="circle-parent">
      <div class="circle-heading">
        <span class="circle-heading-title">
          <span class="title-main">よくある</span>
          <span class="title-sub">質問</span>
        </span>
      </div>
    </div>

    <div class="home-faq-list">
      <home-question-and-answer
        :number="1"
        :question="'注文してから発送までどれくらいの時間がかかりますか？'"
        :answer="
          `ネットでのご注文は年中無休 24 時間受け付けております。
          ご注文を受けてから 1 ～ 3 営業日（休業日を除く）で、メーカーから商品を直接発送いたします。
          ※但し、在庫の有る商品に限ります。`
        "
      />
      <home-question-and-answer
        :number="2"
        :question="'商品の保証期間はいつまでですか？'"
        :answer="
          `販売後 1 年間の無償保証修理を行っております。（故意によるものは除きます）
          ※エコチャイムのみ販売後 3 年間の無償保証修理を行っております。
          また、それ以降でも有償となりますが、いつでも迅速に修理させていただきます。
          また、保証期間中はもちろん保証期間外でも修理期間中は貸出機をご提供するなどのサービスを行っています。`
        "
      />
      <home-question-and-answer
        :number="3"
        :question="'どの商品が良いのか自分では選べません'"
        :answer="
          `お悩みの場合は、まずお問合せ下さい。
          担当者がお客様のご要望をお聞きして、最適な商品構成をご提案させていただきます。`
        "
      />
    </div>

    <div class="home-faq-button-wrap">
      <router-link to="/faq" class="home-faq-button">
        よくある質問一覧
      </router-link>
    </div>
  </div>
</template>

<script>
import HomeQuestionAndAnswer from '@/components/modules/HomeQuestionAndAnswer'

export default {
  components: {
    HomeQuestionAndAnswer,
  },
}
</script>

<style scoped>
.home-faq {
  margin: 60px 0 40px;

  text-align: center;
}

.home-faq >>> .circle-heading {
  width: 120px;
  height: 120px;
}

.home-faq >>> .circle-heading-title {
  line-height: 1.2;
}

.home-faq >>> .title-main {
  font-size: 26px;
  display: block;
}

.home-faq >>> .title-sub {
  font-size: 26px;
  display: block;
}

.home-faq-list {
  max-width: 1000px;
  margin: 80px auto 0;
  padding: 0 20px;

  text-align: left;
}

.home-faq-button-wrap {
  display: flex;
  justify-content: center;

  margin-top: 30px;
  padding: 0 5%;
}

.home-faq-button {
  font-size: 18px;
  font-weight: bold;

  display: block;

  width: 100%;
  max-width: 400px;
  padding: 14px 10px;

  text-align: center;
  text-decoration: none;
  letter-spacing: 1px;

  color: #ffffff;
  border-radius: 6px;
  border-bottom: 4px solid rgb(15, 58, 120);
  background-color: rgb(26, 87, 167);
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);

  transition: opacity 0.3s;
}

.home-faq-button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/HomeFaq.vue